export enum ProductRatingType {
    FUNDAMENTAL = "FUNDAMENTAL",
    INFORM = "INFORM",
}
